import { render, staticRenderFns } from "./RedirectIndex.vue?vue&type=template&id=7bd47942&"
import script from "./RedirectIndex.vue?vue&type=script&lang=js&"
export * from "./RedirectIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports